<script setup lang="ts">
// The worker avatar's head and shoulders in a circle, as a standalone image. Size it with CSS.
import { computed, useId } from 'vue';
import WorkerAvatar from './WorkerAvatar.vue';
import { workerAvatarColors } from './worker-avatar';
import type { WorkerAvatarLook } from '../../cross-app-shared/types/worker-avatar';

const props = defineProps<{
  look: WorkerAvatarLook;
}>();

const clipID = useId();
const background = computed(() => workerAvatarColors(props.look).faceBackground);

// The circle, in the artwork's units: centred on the hat and glasses, and cut off at the chest.
const CX = 174;
const CY = 168.3;
const R = 123.1;
</script>

<template>
  <svg :viewBox="`${CX - R} ${CY - R} ${2 * R} ${2 * R}`" aria-hidden="true">
    <defs>
      <clipPath :id="clipID"><circle :cx="CX" :cy="CY" :r="R" /></clipPath>
    </defs>
    <circle :cx="CX" :cy="CY" :r="R" :fill="background" />
    <!-- Mirrored, as on the landing page. -->
    <g :clip-path="`url(#${clipID})`" :transform="`translate(${2 * CX},0) scale(-1,1)`">
      <WorkerAvatar :look pose="portrait" />
    </g>
  </svg>
</template>
